import { LocaleContext } from "common/contexts/LangageContext";
import { useContext } from "react";

const useGetLangageContext = () => {
    const langageContext = useContext(LocaleContext)
    if (!langageContext) {
        console.error('Error fetching langage context')
    }
    return { langageContext }
}
export default useGetLangageContext;